import { useMutation, useQueryClient } from "react-query";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useDeleteFlaggedEmail = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, { id: string }>(
    ({ id }) => mutateDeleteFn(ENDPOINTS.FLAGGED_EMAIL_DELETE.replace(":id", id), {}),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.FLAGGED_EMAILS]);
      },
    }
  );
};
